// extracted by mini-css-extract-plugin
export default {"custom_tablebody_tr":"Roles_custom_tablebody_tr__-k0-a","stickyHeader":"Roles_stickyHeader__bW7pa","stickyBody":"Roles_stickyBody__FKW1k"};